export default __webpack_public_path__ + "static/media/logoTrimmed.0e30bf87.png";